import { defineComponent, ComponentPublicInstance, createApp, reactive } from 'vue'
import TSpin from './index.vue'
interface ISpinParams {
    title?: string
    description?: string
    transparent?: boolean
    theme?: 'default' | 'highlight'
}

function createSpin() {
    const state = reactive({
        isShow: false,
        title: TSpin.props.title.default,
        description: TSpin.props.title.description,
        theme: TSpin.props.theme.default,
        transparent: TSpin.props.transparent.default,
    })

    let instance: ComponentPublicInstance | undefined = undefined
    const _spin = defineComponent({
        components: { TSpin },
        setup() {
            return () => (
                <t-spin
                    v-model={state.isShow}
                    type="fixed"
                    title={state.title}
                    description={state.description}
                    theme={state.theme}
                    transparent={state.transparent}
                />
            )
        },
    })

    const show = (params?: ISpinParams) => {
        const fixedSpin = document.getElementsByClassName('t-spin-fixed')
        if (!instance && fixedSpin.length === 0) {
            const div = document.createElement('div')
            instance = createApp(_spin).mount(div)
            document.body.appendChild(instance.$el)
        }
        state.isShow = true
        state.title = (params && params.title) || TSpin.props.title.default
        state.description = (params && params.description) || TSpin.props.description.default
        state.theme = (params && params.theme) || TSpin.props.theme.default
        state.transparent = (params && params.transparent) || TSpin.props.transparent.default
    }
    const hide = () => {
        state.isShow = false
        state.title = ''
        state.description = ''
    }

    return { show, hide }
}

export const spin = createSpin()
